const shippingPreferenceSelector =
  'input[name="attributes[Shipping Preference]"]';
const shippingPreferenceContainerSelector = '[data-shipping-preference]';
const shippingPreferenceCheckoutSelector =
  '#drawer-checkout-button, #cart-checkout-button';
const dynamicCheckoutSelector = '[data-shipping-preference-dynamic-checkout]';

const updateShippingPreferenceCheckoutState = () => {
  const shippingPreferenceContainer = document.querySelector(
    shippingPreferenceContainerSelector
  );
  const shippingPreferenceRequired = Boolean(shippingPreferenceContainer);
  const hasShippingPreference = Boolean(
    document.querySelector(`${shippingPreferenceSelector}:checked`)
  );
  const shouldDisableCheckout =
    shippingPreferenceRequired && !hasShippingPreference;

  document
    .querySelectorAll(shippingPreferenceCheckoutSelector)
    .forEach(checkoutButton => {
      checkoutButton.disabled = shouldDisableCheckout;
    });

  document.querySelectorAll(dynamicCheckoutSelector).forEach(checkoutButton => {
    checkoutButton.classList.toggle('hidden', shouldDisableCheckout);
  });
};

const saveShippingPreference = value => {
  if (!window.routes?.cart_update_url) {
    return;
  }

  fetch(routes.cart_update_url, {
    ...fetchConfig(),
    body: JSON.stringify({
      attributes: {
        'Shipping Preference': value
      }
    })
  }).catch(error => {
    console.error('Error saving shipping preference:', error);
  });
};

document.addEventListener('change', event => {
  if (!event.target.matches(shippingPreferenceSelector)) {
    return;
  }

  updateShippingPreferenceCheckoutState();
  saveShippingPreference(event.target.value);
});

document.addEventListener(
  'DOMContentLoaded',
  updateShippingPreferenceCheckoutState
);
